export interface Fact {
  category: string;
  title: string;
  body: string;
}

export const facts: Fact[] = [
  {
    category: "Advertising",
    title: "Diamonds are not actually rare",
    body: "<strong>De Beers</strong> had a demand problem in the 1930s, so it hired an ad agency. By 1947 a young copywriter, Frances Gerety, had written four words: “A Diamond Is Forever”. The “spend two months’ salary” rule came from the same campaign. Geology had nothing to do with any of it.",
  },
  {
    category: "Advertising",
    title: "Mouthwash needed a disease first",
    body: "In the 1920s <strong>Listerine</strong> was a struggling floor cleaner and surgical antiseptic. So its makers dusted off an obscure medical word, <strong>halitosis</strong>, and recast ordinary bad breath as a social emergency. Sales climbed from the hundreds of thousands into the millions.",
  },
  {
    category: "Advertising",
    title: "The Marlboro cowboy used to be a lady",
    body: "Marlboro launched in the 1920s as a women’s cigarette, with the slogan “Mild as May” and a red tip to hide lipstick marks. The rugged cowboy arrived in 1954, when Leo Burnett was brought in to make the brand feel masculine. It worked rather too well.",
  },
  {
    category: "Advertising",
    title: "Red Bull was borrowed from Thailand",
    body: "Dietrich Mateschitz didn’t invent the energy drink. He tried a Thai tonic called <strong>Krating Daeng</strong> on a business trip, found it fixed his jet lag, and licensed it for the West. “Red Bull” is simply the translation.",
  },
  {
    category: "Advertising",
    title: "“Got Milk?” sold the absence, not the drink",
    body: "The 1993 campaign never showed how nice milk is. It showed people with a mouthful of peanut butter and an empty carton, at the precise moment of regret. Selling the <strong>deprivation</strong> beat selling the product.",
  },
  {
    category: "Advertising",
    title: "Being number two can be the whole pitch",
    body: "In 1962 the hire-car firm <strong>Avis</strong> admitted it was only second to Hertz, with the line “We try harder”. Confessing the weakness made the brand more trusted, not less. The campaign ran for half a century.",
  },
  {
    category: "Advertising",
    title: "If it rhymes, we believe it more",
    body: "People rate rhyming statements as more accurate than the very same claim in plain prose. Psychologists call it the <strong>rhyme-as-reason effect</strong>. It is also why “a Mars a day helps you work, rest and play” lodged in your head and refuses to leave.",
  },
  {
    category: "Behavioural science",
    title: "A painted fly that saved a fortune in cleaning",
    body: "Schiphol Airport etched a small image of a fly into the urinals, just off-centre, to give men a target. “Spillage” and the cleaning bill dropped sharply. A picture beat every “please aim carefully” sign ever printed.",
  },
  {
    category: "Behavioural science",
    title: "The form, not the values, decides",
    body: "Countries where organ donation is <strong>opt-out</strong> have consent rates above 90%. Opt-in countries hover around 15%. Same humans, same compassion. The only real difference is which box was already ticked.",
  },
  {
    category: "Behavioural science",
    title: "One mint, 3% tip. Two mints, 20%.",
    body: "A waiter who left a single sweet with the bill earned about 3% more in tips. Two sweets, handed over with a little “and because you’re lovely, here’s an extra”, earned over 20% more. The mints cost pennies.",
  },
  {
    category: "Behavioural science",
    title: "The magic word is “because”",
    body: "In a 1978 study, asking to jump a photocopier queue worked far better when the request ended with “because”, even when the reason was nonsense: “because I need to make copies”. We respond to the <strong>shape</strong> of a reason, not always its content.",
  },
  {
    category: "Behavioural science",
    title: "The pointless option that sells the dear one",
    body: "The Economist once offered web for $59, print for $125, or print and web for… also $125. Almost nobody chose print-only, yet its mere presence nudged most people to the top tier. A decoy you’d never pick is still doing the selling.",
  },
  {
    category: "Behavioural science",
    title: "Losing hurts twice as much as winning",
    body: "Losing £10 feels roughly twice as bad as finding £10 feels good. It’s called <strong>loss aversion</strong>, and it means most “save money” pitches would land harder reframed as “stop losing money”.",
  },
  {
    category: "Behavioural science",
    title: "We love the things we build ourselves",
    body: "People will pay more for flat-pack furniture and origami they assembled themselves, even badly, than for identical items made by an expert. The effort creates the affection. Psychologists, with a straight face, call it the <strong>IKEA effect</strong>.",
  },
  {
    category: "Behavioural science",
    title: "An absurd number still moves you",
    body: "Ask people whether Gandhi died before or after the age of 140, then ask how old he actually was, and their guesses creep upward, anchored to a figure they know is ridiculous. The brain grabs the nearest number even when it’s plainly silly.",
  },
  {
    category: "Behavioural science",
    title: "We judge the peak and the ending, not the average",
    body: "Memory keeps the most intense moment of an experience and its final moment, then quietly bins the rest. A long ordeal that ends gently is remembered more fondly than a short one that ends badly. Worth knowing before you plan anything.",
  },
  {
    category: "Behavioural science",
    title: "Spilling your coffee makes you more likeable",
    body: "A competent person who commits a small blunder is rated <strong>more</strong> appealing, not less. The flaw makes the talent feel human. It’s the <strong>pratfall effect</strong>, and it’s why flawless people are quietly irritating.",
  },
  {
    category: "Behavioural science",
    title: "We are patient about everything except now",
    body: "Offered £100 today or £110 next week, most people grab the £100. Offered £100 in a year or £110 in a year and a week, most happily wait. The week is identical. Only the word “now” changes our minds.",
  },
  {
    category: "Behavioural science",
    title: "One nice thing demands another",
    body: "The philosopher Denis Diderot got a smart new dressing gown, then noticed everything around it looked shabby, and ended up replacing his whole study. The <strong>Diderot effect</strong> is why a single upgrade quietly triggers a dozen more.",
  },
  {
    category: "Behavioural science",
    title: "Owning something doubles its price",
    body: "Give people a mug and they’ll demand roughly twice as much to part with it as they’d have paid to buy it minutes earlier. The instant something is “yours”, it’s worth more. This is the <strong>endowment effect</strong>, and every “free trial” relies on it.",
  },
  {
    category: "Behavioural science",
    title: "Canned laughter genuinely works",
    body: "Add a laugh track and people find the same joke funnier, even though everyone knows the laughter is fake and the audience doesn’t exist. We constantly borrow other people’s reactions to decide our own. Mildly humiliating, completely reliable.",
  },
  {
    category: "Psychology",
    title: "Too much choice can stop the sale",
    body: "A famous jam stall offered shoppers either 24 varieties or 6. The big display pulled a bigger crowd, but the small one sold around ten times as much. Faced with too many options, people often choose nothing at all.",
  },
  {
    category: "Psychology",
    title: "In a blind test, you prefer Pepsi",
    body: "Strip the labels and more people pick Pepsi. Show the logos and Coke wins easily, and brain scans show the branding lighting up a different region entirely. You are not tasting the drink. You are tasting the marketing.",
  },
  {
    category: "Psychology",
    title: "The most famous proof of subliminal ads was a hoax",
    body: "The 1950s experiment that supposedly flashed “eat popcorn” and “drink Coke” at cinema-goers? Its author, James Vicary, admitted in 1962 that he’d <strong>made the data up</strong>. The most cited evidence for subliminal advertising never actually happened.",
  },
  {
    category: "Psychology",
    title: "The “10% of your brain” thing is nonsense",
    body: "You use virtually all of your brain, just not every part at once. The myth is wonderfully persistent, probably because it implies a thrilling 90% of untapped genius waiting inside. There isn’t.",
  },
  {
    category: "Psychology",
    title: "The tongue “taste map” is wrong",
    body: "You were taught that sweet sits at the tip and bitter at the back. In fact every region of the tongue detects every taste. The famous map came from a mistranslated German paper and somehow survived a century of textbooks.",
  },
  {
    category: "Psychology",
    title: "Nobody noticed your mistake",
    body: "We wildly overestimate how much other people clock our stumbles, stains and bad-hair days. It’s the <strong>spotlight effect</strong>. Almost nobody saw the thing you’re still cringing about. They were too busy worrying about their own.",
  },
  {
    category: "Psychology",
    title: "Learn a word, then hear it everywhere",
    body: "Discover a new term and it suddenly seems to appear constantly. It was always there. Your attention simply changed, and your brain started flagging it. The lovely name for this is the <strong>frequency illusion</strong>.",
  },
  {
    category: "Psychology",
    title: "Napoleon wasn’t short",
    body: "At around 5 foot 7, he was average or slightly tall for his era. The “tiny tyrant” was a mix of English propaganda, a confusing gap between French and English inches, and the nickname “the little corporal”. History is unfair to the medium-sized.",
  },
  {
    category: "Psychology",
    title: "Placebos work even when you know",
    body: "In trials, patients told outright that their pill was a sugar placebo still reported real relief from their symptoms. The ritual of treatment does something on its own. The brain, it seems, is not a difficult audience to please.",
  },
  {
    category: "Psychology",
    title: "The famous bystander story was exaggerated",
    body: "The 1964 case used to teach the “bystander effect”, in which 38 people supposedly watched a murder and did nothing, was heavily overstated by the press. The effect is real. The headline that launched it was mostly fiction.",
  },
  {
    category: "Innovation",
    title: "Kodak invented the digital camera, then buried it",
    body: "A Kodak engineer built the first digital camera in 1975. The company shelved it, terrified it would eat into film sales. It later went bankrupt for precisely the reason it was trying to avoid. The future arrives whether you sell it or not.",
  },
  {
    category: "Innovation",
    title: "Blockbuster could have bought Netflix for $50m",
    body: "Around 2000, Netflix offered to sell itself to Blockbuster for fifty million dollars. Blockbuster reportedly all but laughed them out of the room. Netflix is now worth a great deal more, and Blockbuster is a quiz answer.",
  },
  {
    category: "Innovation",
    title: "Post-it Notes began as a failed glue",
    body: "A 3M scientist trying to make a strong adhesive accidentally made a feeble one that barely stuck. Years later a colleague used it to keep bookmarks in his hymnbook. The mistake became one of the company’s best-selling products.",
  },
  {
    category: "Innovation",
    title: "The microwave was discovered by a melted snack",
    body: "An engineer standing near active radar equipment noticed the snack in his pocket had melted. Rather than panic, he pointed the device at some popcorn. The kitchen microwave is a happy accident of military hardware.",
  },
  {
    category: "Innovation",
    title: "WD-40 means “the 40th attempt”",
    body: "The name stands for <strong>Water Displacement, 40th formula</strong>. The first 39 versions didn’t make the cut. It’s a lab notebook that escaped into garages worldwide, and a quiet monument to not giving up at attempt 39.",
  },
  {
    category: "Innovation",
    title: "The NASA space pen story is a myth",
    body: "“NASA spent millions on a zero-gravity pen while the Russians just used a pencil.” Lovely tale, entirely false. The Fisher Space Pen was developed <strong>privately</strong>, and pencils were a real hazard up there: loose graphite conducts electricity and the tips are flammable.",
  },
  {
    category: "Innovation",
    title: "Penicillin came from a dirty dish",
    body: "Alexander Fleming returned from holiday to a mouldy, contaminated petri dish he’d forgotten to clean. Most people would have binned it. He looked closer and saw the mould was killing the bacteria. Tidiness is occasionally overrated.",
  },
  {
    category: "Innovation",
    title: "Velcro was invented by a dog walk",
    body: "A Swiss engineer kept finding burdock burrs stuck to his trousers and his dog after country walks. He studied the little hooks under a microscope and copied them. We call the result Velcro, and it took him the best part of a decade to perfect.",
  },
  {
    category: "Innovation",
    title: "Play-Doh was a wallpaper cleaner",
    body: "It was first sold to scrub coal soot off wallpaper. When homes switched to cleaner heating, sales collapsed, until someone noticed children loved squishing it. A dying cleaning product became a classic toy with one change of audience.",
  },
  {
    category: "Innovation",
    title: "Bubble wrap was meant to be wallpaper",
    body: "Its inventors were trying to make a trendy textured wall covering. Nobody wanted it. It briefly became greenhouse insulation before finding its true calling protecting parcels, and giving the rest of us something to pop.",
  },
  {
    category: "Innovation",
    title: "Viagra was a heart drug that failed upward",
    body: "It was trialled as a treatment for angina. The heart results were unremarkable, but trial participants were curiously reluctant to hand back their leftover pills. The “side effect” turned out to be the actual product.",
  },
];
